<template>
  <div class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200">
  </div>
</template>

<style scoped>
.loader {
  border-top-color: #3498db;
  animation: spinner 1.5s linear infinite;
  width: 100%;
  height: 100%;
  min-width: 1rem;
  min-height: 1rem;
  box-sizing: border-box;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>